<script setup lang="ts">
defineOptions({ name: 'AccessCenter' })
defineProps<{ src: string }>()
</script>

<template>
  <div class="access-center">
    <iframe id="documentIframe" class="iframe" :src="src" />
  </div>
</template>

<style scoped lang="less">
.access-center {
  box-sizing: border-box;
  width: 100%;
  min-width: 1280px;
  padding-top: @head-navigation-menu-height;
  height: 100vh;
  .document {
    box-sizing: border-box;
    height: calc(100% - 6px);
    background-color: #fff;
  }
  .iframe {
    box-sizing: border-box;
    height: calc(100% - 6px);
    width: 100%;
    border: none;
  }
}
</style>
